import { useLanguage } from "../i18n/LanguageContext";
import { locales, type Locale } from "../i18n/translations";

type HeaderProps = {
    onOpenContactForm: () => void;
};

export function Header({ onOpenContactForm }: HeaderProps) {
    const { locale, setLocale, t } = useLanguage();

    return (
        <header className="header">
            <a className="logo" href="#top" aria-label="Table One">
                <span className="logoIcon">T</span>
                <span>Table One</span>
            </a>

            <nav className="nav">
                <a href="#features">{t.header.features}</a>
                <a href="#device">{t.header.device}</a>
                <a href="#restaurants">{t.header.restaurants}</a>
                <a href="#integrations">{t.header.integrations}</a>
                <a href="#flex">{t.header.flex}</a>
                <a href="#contacts">{t.header.contacts}</a>
            </nav>

            <div className="headerActions">
                <div className="langSwitch" role="group" aria-label={t.header.language}>
                    {locales.map((item: Locale) => (
                        <button
                            key={item}
                            className={`langButton${locale === item ? " active" : ""}`}
                            type="button"
                            onClick={() => setLocale(item)}
                        >
                            {item.toUpperCase()}
                        </button>
                    ))}
                </div>

                <button className="headerButton" type="button" onClick={onOpenContactForm}>
                    {t.header.discussPilot} <span>→</span>
                </button>
            </div>
        </header>
    );
}
